import { useState, useEffect } from "react"


let col
let row
let canChange = false
let counterTime = 60

const usePlay = () => {

    const initialGrid = [[0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0]]

    const [history, setHistory] = useState([])
    const [grid, setGrid] = useState(initialGrid)
    const [player, setPlayer] = useState(1)
    const [timerCounter, setTimerCounter] = useState(counterTime)
    const [winner, setWinner] = useState(null)
    const [player1Wins, setPlayer1Wins] = useState(0)
    const [player2Wins, setPlayer2Wins] = useState(0)
    const [wait, setWait] = useState(false)
    const [winnerPos, setWinnerPos] = useState(null)
    const [pause, setPause] = useState(false)

    const setNewDisk = (colum) => {

        col = null
        row = null
        for (let index in grid) {
            if (grid[index][colum] === 0) {
                col = colum
                row = index
            }
            else { break }
        }

        let move = updateGrid()
        setHistory([...history, move])
    }

    const updateGrid = () => {
        if (row != null && col != null) {
            grid[row][col] = player
            setGrid([...grid])
            canChange = true
            return { row: String(row), col: String(col), player: player }
        }
    }

    const changePlayer = () => {
        (player === 1) ? setPlayer(2) : setPlayer(1)
        setTimerCounter(counterTime)
    }

    const checkWin = () => {

        row = Number(row);
        col = Number(col);

        // //Vertically
        // //row-3 >= 0 && (grid[row-1][col] === player) && (grid[row-2][col] === player) && (grid[row-3][col] === player) && setWhoWins(player, [[row,col],[row-1,col],[row-2,col],[row-3,col]])
        // row + 3 <= 5 && (grid[row + 1][col] === player) && (grid[row + 2][col] === player) && (grid[row + 3][col] === player) && setWhoWins(player, [[row, col], [row + 1, col], [row + 2, col], [row + 3, col]])

        // //Horizontally
        // col - 3 >= 0 && (grid[row][col - 1] === player) && (grid[row][col - 2] === player) && (grid[row][col - 3] === player) && setWhoWins(player, [[row, col], [row, col - 1], [row, col - 2], [row, col - 3]])
        // col + 3 <= 6 && (grid[row][col + 1] === player) && (grid[row][col + 2] === player) && (grid[row][col + 3] === player) && setWhoWins(player, [[row, col], [row, col + 1], [row, col + 2], [row, col + 3]])

        // //Horizontally intern check
        // col + 1 <= 6 && col - 2 >= 0 && (grid[row][col - 2] === player) && (grid[row][col - 1] === player) && (grid[row][col + 1] === player) && setWhoWins(player, [[row, col], [row, col - 2], [row, col - 1], [row, col + 1]])
        // col + 2 <= 6 && col - 1 >= 0 && (grid[row][col - 1] === player) && (grid[row][col + 1] === player) && (grid[row][col + 2] === player) && setWhoWins(player, [[row, col], [row, col - 1], [row, col + 1], [row, col + 2]])

        // //Diagonally up
        // row - 3 >= 0 && col - 3 >= 0 && (grid[row - 1][col - 1] === player) && (grid[row - 2][col - 2] === player) && (grid[row - 3][col - 3] === player) && setWhoWins(player, [[row, col], [row - 1, col - 1], [row - 2, col - 2], [row - 3, col - 3]])
        // row - 3 >= 0 && col + 3 <= 6 && (grid[row - 1][col + 1] === player) && (grid[row - 2][col + 2] === player) && (grid[row - 3][col + 3] === player) && setWhoWins(player, [[row, col], [row - 1, col + 1], [row - 2, col + 2], [row - 3, col + 3]])

        // //Diagonally down
        // row + 3 <= 5 && col - 3 >= 0 && (grid[row + 1][col - 1] === player) && (grid[row + 2][col - 2] === player) && (grid[row + 3][col - 3] === player) && setWhoWins(player, [[row, col], [row + 1, col - 1], [row + 2, col - 2], [row + 3, col - 3]])
        // row + 3 <= 5 && col + 3 <= 6 && (grid[row + 1][col + 1] === player) && (grid[row + 2][col + 2] === player) && (grid[row + 3][col + 3] === player) && setWhoWins(player, [[row, col], [row + 1, col + 1], [row + 2, col + 2], [row + 3, col + 3]])

        // //Diagonally intern check
        // //Left
        // row + 2 <= 5 && col - 2 >= 0 && row - 1 >= 0 && col + 1 <= 6 && (grid[row + 2][col - 2] === player) && (grid[row + 1][col - 1] === player) && (grid[row - 1][col + 1] === player) && setWhoWins(player, [[row, col], [row + 2, col - 2], [row + 1, col - 1], [row - 1, col + 1]])
        // row + 1 <= 5 && col - 1 >= 0 && row - 2 >= 0 && col + 2 <= 6 && (grid[row + 1][col - 1] === player) && (grid[row - 1][col + 1] === player) && (grid[row - 2][col + 2] === player) && setWhoWins(player, [[row, col], [row + 1, col - 1], [row - 1, col + 1], [row - 2, col + 2]])
        // //Right
        // row + 2 <= 5 && col + 2 <= 6 && row - 1 >= 0 && col - 1 >= 0 && (grid[row - 1][col - 1] === player) && (grid[row + 1][col + 1] === player) && (grid[row + 2][col + 2] === player) && setWhoWins(player, [[row, col], [row - 1, col - 1], [row + 1, col + 1], [row + 2, col + 2]])
        // row + 1 <= 5 && col + 1 <= 6 && row - 2 >= 0 && col - 2 >= 0 && (grid[row - 2][col - 2] === player) && (grid[row - 1][col - 1] === player) && (grid[row + 1][col + 1] === player) && setWhoWins(player, [[row, col], [row - 2, col - 2], [row - 1, col - 1], [row + 1, col + 1]])


        for (let i = 0; i < 6; i++) {
            for (let j = 0; j < 7; j++) {
                if (grid[i][j] === player) {
                    if (i + 3 < 6 && grid[i + 1][j] === player && grid[i + 2][j] === player && grid[i + 3][j] === player) {
                        setWhoWins(player, [[i, j], [i + 1, j], [i + 2, j], [i + 3, j]])
                        return true
                    }
                    if (j + 3 < 7 && grid[i][j + 1] === player && grid[i][j + 2] === player && grid[i][j + 3] === player) {
                        setWhoWins(player, [[i, j], [i, j + 1], [i, j + 2], [i, j + 3]])
                        return true
                    }
                    if (i + 3 < 6 && j + 3 < 7 && grid[i + 1][j + 1] === player && grid[i + 2][j + 2] === player && grid[i + 3][j + 3] === player) {
                        setWhoWins(player, [[i, j], [i + 1, j + 1], [i + 2, j + 2], [i + 3, j + 3]])
                        return true
                    }
                    if (i - 3 >= 0 && j + 3 < 7 && grid[i - 1][j + 1] === player && grid[i - 2][j + 2] === player && grid[i - 3][j + 3] === player) {
                        setWhoWins(player, [[i, j], [i - 1, j + 1], [i - 2, j + 2], [i - 3, j + 3]])
                        return true
                    }
                }
            }
        }
        return false
    }

    const checkDraw = () => {
        let draw = true
        for (let row of grid) {
            for (let cell of row) {
                if (cell === 0) {
                    draw = false
                    break
                }
            }
        }
        if (draw) {
            setWinner(-1)
            setTimerCounter(0)
            canChange = false
        }
    }

    const addWinner = (playerNum, direction = 1) => {

        if (playerNum === 1) {
            setPlayer1Wins(player1Wins + direction)
        }
        else if (playerNum === 2) {
            setPlayer2Wins(player2Wins + direction)
        }
    }

    const setWhoWins = (playerNum, hasGrid) => {
        if (hasGrid) {
            setWinnerPos(hasGrid)
        }
        setWinner(playerNum)
        addWinner(playerNum)
        setTimerCounter(0)
        canChange = false
    }

    const playAgain = (restart) => {

        if (restart) {
            (player === 2) ? changePlayer() : setTimerCounter(counterTime)
            setPlayer1Wins(0)
            setPlayer2Wins(0)
        } else { changePlayer() }

        canChange = false
        setWinner(null)
        setGrid(initialGrid)
        setWinnerPos(null)
        setHistory([])

    }

    const undo = (cpu) => {
        //undo a move
        if (history.length > 0) {
            let lastMove = history.pop()
            grid[lastMove.row][lastMove.col] = 0
            setGrid([...grid])
            setPlayer(lastMove.player)
            setTimerCounter(counterTime)
            canChange = false
            setWinner(null)
            setWinnerPos(null)
        }
        //undo two moves if playing against the cpu
        if(cpu){
            undo()
        }

    }

    useEffect(() => {
        setWait(true)
        const timer = setTimeout(() => {
            setWait(false);
            checkWin() || checkDraw();
            canChange && changePlayer();
        }, 600);

        return () => clearTimeout(timer);
        // eslint-disable-next-line
    }, [grid])


    return {
        grid,
        player,
        setNewDisk,
        timerCounter,
        setTimerCounter,
        winner,
        setWhoWins,
        player1Wins,
        player2Wins,
        playAgain,
        undo,
        wait,
        setWait,
        winnerPos,
        pause,
        setPause,
    }
}


export { usePlay }
